import { auth } from 'api';
import {
  SET_AUTH_PROPERTY,
  POST_LOGIN_IDENTITY,
  GET_LOGIN_ENTRAID,
  SET_USER_INFO,
  RESTORE_SESSION,
  GET_USER_INFO,
  GET_LOGOUT,
  POST_USER_SESSION
} from 'store/actions/auth';
import {
  lsSetLoginProfile,
  lsRemoveLoginProfile,
  lsGetLoginProfile,
  lsRemoveDataSignout
} from 'helpers/store';

export default {
  [SET_AUTH_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_AUTH_PROPERTY, { field, value }),

  [POST_LOGIN_IDENTITY]: (_, { user, password }) =>
    new Promise((resolve, reject) => {
      lsRemoveLoginProfile();

      auth.postLoginIdentity({ user, password }).then(
        resp => {
          if (resp.data.redirectUrl) {
            window.location.href = resp.data.redirectUrl;
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: 'Falta la url de redirección al login corporativo'
            });
          }
        },
        err => {
          console.log('Error POST_LOGIN_IDENTITY ', err.response);
          reject(err.response.data);
        }
      );
    }),

  [GET_LOGIN_ENTRAID]: (_, { user }) =>
    new Promise((resolve, reject) => {
      lsRemoveLoginProfile();

      auth.getLoginEntraId({ user }).then(
        resp => {
          // Si viene url de redirección a identity (caso de empleados), hacer redirección y luego llegará por oidc-callback (llamar a get user info después)
          if (resp.data.redirectUrl) {
            // redireccion
            window.location.href = resp.data.redirectUrl;
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: 'Falta la url de redirección al login corporativo'
            });
          }
        },
        err => {
          console.log('Error GET_LOGIN_ENTRAID ', err.response);
          reject(err.response.data);
        }
      );
    }),

  [POST_USER_SESSION]: ({ commit }, payload) =>
    new Promise((resolve, reject) => {
      auth.postUserSession(payload).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject(err.response.data);
        }
      );
    }),

  [GET_USER_INFO]: ({ commit }) =>
    new Promise((resolve, reject) => {
      lsRemoveLoginProfile();

      auth.userInfo().then(
        resp => {
          lsSetLoginProfile(resp.data);
          commit(SET_USER_INFO, resp.data);
          resolve();
        },
        err => {
          /* Error al obtener el perfil ESTO FALTA POR CONTROLAR */
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [GET_LOGOUT]: ({ dispatch }) =>
    new Promise((resolve, reject) => {
      auth.getLogout().then(
        async resp => {
          if (resp.data.redirectUrl) {
            lsRemoveDataSignout();
            lsRemoveLoginProfile();
            await dispatch(SET_AUTH_PROPERTY, { field: 'userInfo', value: null });
            window.location.href = resp.data.redirectUrl;
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: 'Falta la url de redirección al logout corporativo'
            });
          }
        },
        err => {
          reject(err);
        }
      );
    }),

  [RESTORE_SESSION]: ({ commit, getters }) =>
    new Promise(resolve => {
      let userInfo = getters.data('userInfo');

      if (!userInfo) {
        userInfo = lsGetLoginProfile();

        if (userInfo) {
          commit(SET_USER_INFO, userInfo);
        }
      }

      resolve(userInfo);
    })
};
